export type MapTypesLngLatBoundsArray = [[number, number], [number, number]]

export class MapTypesLngLat {
  lng: number
  lat: number

  constructor(lng: number, lat: number) {
    this.lng = lng
    this.lat = lat
  }
}

export class MapTypesLngLatBounds {
  sw: MapTypesLngLat
  ne: MapTypesLngLat

  constructor(sw: MapTypesLngLat, ne: MapTypesLngLat) {
    this.sw = sw
    this.ne = ne
  }

  static fromNwSe(nw: MapTypesLngLat, se: MapTypesLngLat): MapTypesLngLatBounds {
    const ne = new MapTypesLngLat(se.lng, nw.lat)
    const sw = new MapTypesLngLat(nw.lng, se.lat)
    return new MapTypesLngLatBounds(sw, ne)
  }

  getSouthEast(): MapTypesLngLat {
    return new MapTypesLngLat(this.ne.lng, this.sw.lat)
  }
  getNorthWest(): MapTypesLngLat {
    return new MapTypesLngLat(this.sw.lng, this.ne.lat)
  }

  static fromArray(args: MapTypesLngLatBoundsArray): MapTypesLngLatBounds {
    return new MapTypesLngLatBounds(new MapTypesLngLat(...args[0]), new MapTypesLngLat(...args[1]))
  }

  toArray(): [number, number, number, number] {
    return [this.sw.lng, this.sw.lat, this.ne.lng, this.ne.lat]
  }
}
